
import React from 'react'
import LandingPage from './templates/LandingPage'
import Spacer from './components/Spacer'
import SectionPolitiqueConfidentialite from './sections/SectionPolitiqueConfidentialite'

function PolitiqueConfidentialite() {
  return (
    <LandingPage>
      <Spacer size={"48px"}/>
      <SectionPolitiqueConfidentialite/>
    </LandingPage>
  )
}

export default PolitiqueConfidentialite



